<script>
  import { getAction } from '@/api/manage'

  export default {
    name: 'Itable',
    components: {

    },
    props: {
      columns: {
        type: Array,
        default: () => []
      },
      url: {
        type: String,
        default: ''
      },
      queryParams: {
        type: Object,
        default: () => { }
      }
    },
    data () {
      return {
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        dataSource: [],
        loading: true,
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        if (!this.loading) this.loading = true
        getAction(this.url, {
          ... this.queryParams,
          pageSize: 10, pageNo: 1
        }).then(res => {
          this.loading = false
          this.dataSource = res.result.records
          if (res.result.total) {
            this.ipagination.total = res.result.total
          } else {
            this.ipagination.total = 0
          }
        })
      },

    },

    render () {
      const on = {
        ...this.$listeners
      }

      const props = { ...this.$attrs, ...this.$props, ...{ dataSource: this.dataSource, columns: this.columns } }
      // slots循环
      const slots = Object.keys(this.$slots).map(slot => {
        return (
          <template slot={slot}>{this.$slots[slot]}</template>
        )
      })
      const handleTableChange = (pagination, filters, sorter) => {
        // 分页、排序、筛选变化时触发
        // TODO 筛选

        console.log(pagination)
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field
          this.isorter.order = sorter.order == 'ascend' ? 'asc' : 'desc'
        }
        this.ipagination = pagination
        this.loadData()
      }
      return (
        <a-table onChange={handleTableChange} bordered props={props} loading={this.loading}

          pagination={this.ipagination}

          scopedSlots={this.$scopedSlots} on={on}>
          {slots}
        </a-table>

      )

    }
  }
</script>

<style lang='less' scoped>
  ::v-deep {
    .ant-table-body {
      overflow-x: hidden;
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 5px;
        height: 1px;
      }

      &::-webkit-scrollbar-thumb {
        /*滚动条里面的滑块*/
        border-radius: 5px;
        background: rgba(100, 177, 240, 0.5);
      }

      &::-webkit-scrollbar-track {
        /*滚动条里面轨道背景*/
        border-radius: 5px;
        background: rgba(0, 0, 0, 0.1);
      }
    }
    .ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
      overflow-y: auto !important;
    }
  }
</style>